<template>
    <div>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <p>Please provide details for your emergency contact.</p>
        <p>
            Your emergency contact is the person that would be informed if we
            ever need to talk to someone about your care and support – for
            example if you became ill during the programme.
        </p>
        <p>
            We’ll only ever use these details in the event of an emergency and
            will never disclose data to your emergency contact without your
            permission.
        </p>
        <div class="row">
            <div class="col-lg-8">
                <InputText
                    name="contact_name"
                    :required="isRequired('contact_name')"
                    :error="form.errors.get('contact_name')"
                    v-model="form.contact_name"
                    :is-multiline="false"
                >
                    <template v-slot:question>
                        {{ getField("contact_name").question }}
                    </template>
                </InputText>
                <InputText
                    name="contact_mobile_number"
                    :required="isRequired('contact_mobile_number')"
                    :error="form.errors.get('contact_mobile_number')"
                    v-model="form.contact_mobile_number"
                    :is-multiline="false"
                >
                    <template v-slot:question>
                        {{ getField("contact_mobile_number").question }}
                    </template>
                </InputText>
            </div>
        </div>
        <InputRadioGroup
            name="next_of_kin_relation"
            :required="isRequired('next_of_kin_relation')"
            :error="form.errors.get('next_of_kin_relation')"
            v-model="form.next_of_kin_relation"
            :options="getField('next_of_kin_relation').options"
            :form="form"
            @textarea-updated="form[$event.field] = $event.value"
            @input="form.errors.clear('next_of_kin_relation')"
        >
            <template v-slot:question>
                {{ getField("next_of_kin_relation").question }}
            </template>
        </InputRadioGroup>
    </div>
</template>

<script>
import InputText from "../Form/InputText";
import InputRadioGroup from "../Form/InputRadioGroup";
import Form from "../../Form";
import { isRequired } from "./formHelper.js";

export default {
    name: "StepEmergencyContactDetails",
    components: {
        InputText,
        InputRadioGroup,
    },
    methods: {
        getField(fieldName) {
            return this.fields[fieldName];
        },
        isRequired(fieldName) {
            var fieldData = this.getField(fieldName);
            return isRequired(fieldData, this.form);
        },
    },
    data: function () {
        return {
            form: new Form({
                contact_name: null,
                contact_mobile_number: null,
                next_of_kin_relation: null,
                other_relation_text: null,
            }, this.formData),
        };
    },
    props: {
        step: Object,
        fields: Object,
        formData: Object,
    },
};
</script>